import { Box, InputBase, Stack, TextField, Typography, styled } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import palette from '../theme/palette';

export const InputContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  borderRadius: '0.4rem',
  padding: '0.2rem 0.4rem',
  backgroundColor: palette.visitor.input.bg,
  border: palette.visitor.input.border,
}));

export const StyledInput = styled(InputBase)(({ theme }) => ({
  marginLeft: 8,
  fontSize: '0.8rem',
  fontWeight: 900,
  fontFamily: 'sans-serif',
  flexGrow: 1,
  color: palette.visitor.input.color,
  input: {
    '&::placeholder': {
      opacity: 0.9,
      color: palette.visitor.input.placeholder,
      fontWeight: 900,
    },
  },
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  // fontSize: '0.8rem',
  // fontWeight: 900,
  fontFamily: 'sans-serif',
  flexGrow: 1,
  color: palette.visitor.input.color,
  border: 'none',
  input: {
    fontSize: '0.8rem',
    fontWeight: 900,
    '&::placeholder': {
      opacity: 0.9,
      color: palette.visitor.input.placeholder,
      fontWeight: 900,
      fontSize: '0.8rem',
    },
  },
}));

export const ThemeButton = styled(LoadingButton)(({ theme }) => ({
  background: palette.button.bg,
  color: palette.visitor.login.color,
  borderRadius: '10px',
  // border: palette.button.border,
  // boxShadow: palette.button.shadow,
  textShadow: '0 0 1px rgba(0, 0, 0, 0.6), 0 0 2px rgba(0, 0, 0, 0.4)',
  fontSize: '1rem',
  overflow: 'hidden',
  height: '44px',
  '&: disabled': {
    boxShadow: 'none',
  },
  '&::after': {
    content: '""',
    backgroundImage: `url(${require('../assets/theme-button-bg.webp')})`,
    backgroundSize: '100% 100%',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
  },
}));

export const TableHeadCustomStyle = {
  backgroundColor: 'black',
  borderCollapse: 'separate',
  '& th': {
    borderTop: '1px solid white',
    borderBottom: '1px solid white',
    color: 'white',
  },
  '& th:first-of-type': {
    paddingLeft: 2,
    borderLeft: '1px solid white',
    borderTop: '1px solid white',
    borderBottom: '1px solid white',
  },
  '& th:last-of-type': {
    paddingRight: 2,
    borderRight: '1px solid white',
    borderTop: '1px solid white',
    borderBottom: '1px solid white',
  },
};

export const SectionHeader = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(273.4deg, rgba(165, 0, 0, 0) 12.81%, #FC0404 96.52%)',
  borderRadius: '5px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '4px 5px',
  marginBottom: '10px',
}));

export const SectionIconWrapper = styled(Box)(({ theme }) => ({
  width: '23px',
  minWidth: '23px',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    width: '12%',
  },
  [theme.breakpoints.up('md')]: {
    width: '15%',
  },
  [theme.breakpoints.up('lg')]: {
    width: '5%',
  },
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '14px',
  [theme.breakpoints.up('sm')]: {
    fontSize: '15px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '17px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '19px',
  },
}));

export const CardTitleAlt = styled(Box)(({ theme }) => ({
  fontWeight: 600,
  fontSize: 17,
  background: 'linear-gradient(to bottom, rgba(49, 49, 49), rgba(77, 77, 77))',
  padding: '.325rem 3rem',
  borderBottomLeftRadius: 999,
  borderBottomRightRadius: 999,
  borderBottom: '2px solid rgb(96, 96, 96)',
  borderLeft: '2px solid rgb(96, 96, 96)',
  borderRight: '2px solid rgb(96, 96, 96)',
}));
